import React, { Component } from 'react'
import PropTypes from 'prop-types';

import FlatButton from 'material-ui/FlatButton';
import Dialog from 'material-ui/Dialog';
import { List, ListItem, makeSelectable } from 'material-ui/List';
import { Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn } from 'material-ui/Table';
import Subheader from 'material-ui/Subheader';
import RaisedButton from 'material-ui/RaisedButton';
import TextField from 'material-ui/TextField';
import EditSwitch from './EditSwitch';
import AddtionalSettingsPage from './AdditionalSettingsPage';
import { IconButton } from 'material-ui';
import Pagination from 'react-js-pagination';
import {additionalFeaturesConfig} from './AdditionalSettings';
//providers
import DataService from '../../services/DataService';
var ds = DataService;

import LocalStorageService from '../../services/LocalStorageService';
var ls = LocalStorageService;

import Helper from '../../services/Helper';
var help = Helper;

import MessageService from '../../services/MessageService';
var _mqtt = MessageService;

var tempArray = [];
var humidArray = [];

export default class RoomControlMain extends Component {
  edit_switch_name = "";
  constructor(props) {
    super(props);
    this.state = {
      all_rooms: [],
      all_rooms_copy: [],
      current_offset: 0,
      activePage: 1,
      totalCount: 0,
      maxItems: 20,
      byroom: null,
      current_switches: [],
      current_devices: [],
      device_statuses: {},
      device_avail: {},
      averageTemp: '',
      averageHumidity: '',
      search_field: "",
      pre_room_id: this.props.room_id,
      edit_switch: null,
      edit_switch_name: "",
      dialog: {
        open: false,
        head: 'Dude',
        body: 'This is working',
        actions: [
          <FlatButton
            label="Okay"
            primary
            onClick={this.closeDialog.bind(this)}
          />
        ]
      },
      isDemoLogin: false
    }
    // this.searchColumnWise = this.searchColumnWise.bind(this);
  }

  maxItems = 10;
  componentDidMount() {
    let userData = ls.getUserDetails();
    if (userData.is_demo_user) {
      this.setState({
        isDemoLogin: true
      });

    } else {
      this.setState({
        isDemoLogin: false
      });
    };
    this.getAllRooms(this.state.current_offset);
    window.addEventListener('_mqt', (e) => {
      if (e && e.detail) {
        if (e.detail.data && e.detail.data.switch) {
          let x = this.state.device_statuses;
          let y = this.state.device_avail;
          if (!x) {
            x = {};
          }
          x[e.detail.device_id] = e.detail.data.switch.relays;
          y[e.detail.device_id] = true;
          this.setState({
            device_statuses: x,
            device_avail: y
          });
        }

        if (e.detail.data && e.detail.data.sns && e.detail.data.sns.temphumid && e.detail.data.sns.temphumid.length) {
          tempArray = [];
          humidArray = [];

          for (let tempObject of e.detail.data.sns.temphumid) {
            if (tempObject) {
              let i = tempObject.v;
              const temp = i.split(',')[0];
              const hum = i.split(',')[1];

              if (temp > 0 && temp < 50) {
                tempArray.push(temp);

              } else {
                tempArray.push(null);
              }
              humidArray.push(hum);

            }
          }
          this.calculateTemp();
        }
      }
    });
  }

  calculateTemp() {
    let tempSum = 0;
    let humidSum = 0;

    tempArray.forEach((temp) => {
      if (temp !== null) {
        tempSum = parseInt(temp) + tempSum;
      }
    });
    tempSum = tempSum / tempArray.length;
    tempSum = Number(tempSum).toFixed(1);

    this.setState({
      averageTemp: tempSum
    });

    humidArray.forEach((humid) => {
      if (humid !== null) {
        humidSum = parseInt(humid) + humidSum;
      }
    });
    humidSum = humidSum / humidArray.length;
  }

  onChangePage(e) {
    this.getSomeRooms(this.maxItems * (e - 1));
    this.setState({
      activePage: e
    })
  }

  getAllRooms(offset, offset_change = 0) {
    ds.getSomeRooms(ls.getUserDetails().hotel_id, 0, offset,
      data => {
        this.setState({
          all_rooms: data,
          all_rooms_copy: data.slice(),
          totalCount: data.length
        }, () => {
          if (this.state.pre_room_id) {
            let ind = 0;
            for (let i of data) {
              if (i._id == this.state.pre_room_id) {
                this.changeCurrentIndex(i.hotel_room_id._id);
                this.setState({
                  pre_room_id: null
                })
                break;
              }
              ind++;
            }
          }
        });
        if (!offset_change) {
          let x = this.state.current_offset;
          this.setState({
            current_offset: offset + this.maxItems
          })
        }
      },
      err => { }
    );

  }

  closeDialog() {
    this.setState({
      dialog: {
        head: '',
        body: '',
        open: false,
        actions: []
      }
    })

  }

  changeCurrentIndex(ind) {
    _mqtt.disconnect()
    ds.getSwitchesInRoom(ind, data => {
      if (data && data.switchAppliances && data.switchAppliances.length) {
        data.switchAppliances.forEach((switchPresent) => {
          switchPresent.loaderFlag = false;
        });
      }
      this.setState({
        byroom: { room_id: ind, ...data },
        current_switches: data && data.switchAppliances ? data.switchAppliances : [],
        device_avail: {}
      });

      if (data.mqttPassword) {
        _mqtt.connect(ind, data.mqttPassword).then(() => {
          for (let i in data.devicesInfo) {
            _mqtt.unsafePublish(ind, i, data.devicesInfo[i].encryptKey);
          }
        });
      }

    }, err => { });

    ds.getDevicesInRoom(ind, data => {
      this.setState({
        current_devices: data
      })
    }, err => { });
  }

  editSwitch(_switch) {
    if (_switch) {
      this.setState({
        dialog: {
          open: true,
          head: '',
          body: <EditSwitch unMountMe={() => {
            this.closeDialog();
          }} switch_appliance={_switch} />,
          actions: []
        }
      })
    }
  }

   // eslint-disable-next-line class-methods-use-this
   unlockdevice(id, kd_id) {
    let startDate, endDate;
    startDate = Date.now();
    endDate = Date.now() + 1000 * 60 * 60 * 6;
    ds.postLockOtp({
      intent: 7,
      hotel_id: ls.getUserDetails().hotel_id,
      keyboardPwdName: "OTP" + Date.now(),
      keyboardPwdType: 1,
      UDid: id,
      startDate,
      endDate,
    }, ({ keyboardPwd }) => {
      if (!keyboardPwd) {
       this.setState({
        dialog: {
          open: true,
          head: 'Error',
          body: 'OTP could not be generated. Try Again!',
          actions: [
            <FlatButton
              label="Okay"
              primary
              onClick={this.closeDialog.bind(this)}
            />
          ]
        },
       })
       return null;
      } else {
        return keyboardPwd;
        // this.setState({
        //   dialog: {
        //     open: true,
        //     head: 'Success',
        //     body: 'Use this OTP to unlock the device - '+ keyboardPwd,
        //     actions: [
        //       <FlatButton
        //         label="Okay"
        //         primary
        //         onClick={this.closeDialog.bind(this)}
        //       />
        //     ]
        //   },
        //  })
      }
    },
    (err) => {
       console.log(err);
    })
  }

  checkForAdditionalSetting(id,kd_id) { // to check for additional setting
    let deviceID = id;
    let hotelID = ls.getUserDetails().hotel_id;
    let additionalFeatures = additionalFeaturesConfig;
    let askString = Object.keys(additionalFeaturesConfig).join(",");
    ds.getUserDeviceAdditionalSettings(deviceID,hotelID, askString,
       (data) => {
        if (data.message) {
          //let displayFeatureArray = [];
          let e = new CustomEvent('success_dialog', { detail: { message: data.message } });
          window.dispatchEvent(e);
          // const recievedSettings = {"features":{"virtual_switch_override":{"supported":true,"data":{"isEnabled":false}}}};
          // for (let key in recievedSettings.features) {
          //   if (recievedSettings.features.hasOwnProperty(key) === additionalFeatures.hasOwnProperty(key)) {
      
          //    // additionalFeatures[key].data = recievedSettings[key].data;
          //    // additionalFeatures[key].supported = recievedSettings[key].supported;
          //     if (recievedSettings.features[key].supported === true) {
          //       displayFeatureArray.push({...additionalFeaturesConfig[key],data:recievedSettings.features[key].data,
          //       supported:recievedSettings.features[key].supported});
          //     }
      
          //   }
          // }
          // this.setState({
          //   dialog: {
          //     open: true,
          //     head: '',
          //     body: <AddtionalSettingsPage unMountMe={() => {
          //       this.closeDialog();
          //     }} settings={displayFeatureArray} userDeviceID={deviceID} kiotDeviceID={kd_id} hotelID={hotelID}/>,
          //     actions: []
          //   }
          // })
        } else {
          let displayFeatureArray = [];
          const recievedSettings = data;
          for (let key in recievedSettings.features) {
            if (recievedSettings.features.hasOwnProperty(key) === additionalFeatures.hasOwnProperty(key)) {
              if (recievedSettings.features[key].supported) {
                displayFeatureArray.push({...additionalFeaturesConfig[key],data:recievedSettings.features[key].data,
                supported:recievedSettings.features[key].supported});
              }
      
            }
          }
          this.setState({
            dialog: {
              open: true,
              head: '',
              body: <AddtionalSettingsPage unMountMe={() => {
                this.closeDialog();
              }} settings={displayFeatureArray} userDeviceID={deviceID} kiotDeviceID={kd_id} hotelID={hotelID}/>,
              actions: []
            }
          })
        }
      },
      (err) => {
        console.log('Error = ', err);
      }

    ); // end of get user additional setting
  }

  searchRooms() {
    if (this.state.search_field) {
      let x = this.state.all_rooms_copy.slice();
      let y = [];
      let searchString = this.state.search_field
      for (let obj of x) {
        if (obj && obj.room_id && obj.room_id.name) {
          let room = obj.room_id.name;
          if (room.toLowerCase().lastIndexOf(searchString.toLowerCase(), 0) === 0) {
            y.push(obj);
          }
        }
      }
      this.setState({
        all_rooms: y
      });
    }
    else {
      this.setState({
        all_rooms: this.state.all_rooms_copy.slice()
      });
    }
  }

  render() {
    let pagination;
    pagination = <Pagination
      activePage={this.state.activePage}
      itemsCountPerPage={this.maxItems}
      totalItemsCount={this.state.totalCount}
      pageRangeDisplayed={5}
      onChange={this.onChangePage.bind(this)}
    />
    return (
      <div className="col-md-12">
        <Dialog
          title={this.state.dialog.head}
          actions={this.state.dialog.actions}
          modal={false}
          open={this.state.dialog.open}
          onRequestClose={this.closeDialog.bind(this)}
        >
          {this.state.dialog.body || 'NA'}
        </Dialog>


        {/* <section className="box box-default col-md-3 mt-4">
                    <div className="box-header">Rooms
                    <section>
                            <TextField
                                floatingLabelText="Search ..."
                                className="w-100"
                                value={this.state.search_field}
                                onChange={(e) => {
                                    this.setState({
                                        search_field: e.target.value
                                    }, () => {
                                        this.searchRooms();
                                    })
                                }}
                            />
                        </section>
                    </div>
                    <div className="box-body" style={{ paddingTop: "0px" }}>
                        <SelectableList currentIndexGetter={this.changeCurrentIndex.bind(this)}>
                            <Subheader>Select a Room</Subheader>
                            {
                                this.state.all_rooms.map((row, index) => {
                                    return (
                                        <ListItem
                                            key={row._id}
                                            value={row.room_id ? row.room_id._id : null}
                                            primaryText={row.room_id ? row.room_id.name : ''}
                                        />)
                                })
                            }

                        </SelectableList>
                    </div>
                </section> */}
        {
          this.state.byroom ?
            <div>
              <section className="box box-default col-md-12 mt-4 customBox ml-1rem">
                <div className="box-header">Appliances
                  <RaisedButton
                    label="Turn Off Room"
                    primary
                    style={{
                      float: "right"
                    }}
                    onClick={() => {
                      this.state.isDemoLogin === false ?
                        ds.postTurnOffRoom({
                          room: this.state.byroom.room_id
                        }, data => { }, err => { })
                        : null
                    }}
                    type="button"
                  />
                  <FlatButton
                    label={"Room Temperature - " + (this.state.averageTemp ? this.state.averageTemp + " °C" : 'NA')}
                    primary
                    style={{
                      float: "right",
                      marginRight: '1rem'
                    }}
                    type="button"
                  />
                </div>

                <div className="box-body row col-12" style={{ paddingRight: "0" }}>
                  {
                    this.state.current_switches && this.state.current_switches.length ?
                      this.state.current_switches.map((obj, ind) => {
                        const hasFeature8 = obj.feature && Array.isArray(obj.feature) && obj.feature.some(f => f.id === 8);
                        const isChecked = this.state.device_statuses && this.state.device_statuses[obj.device_id] ? this.state.device_statuses[obj.device_id][obj.switch_no - 1] ? true : false : false;
                        return (
                        <div className="col-md-2 col-6" style={{ marginBottom: "1rem", padding: "0 0.4rem" }}>
                          <section key={obj._id} className="dark-bg switch-box">
                            {
                              (this.state.device_avail && this.state.device_avail[obj.device_id]) || this.state.isDemoLogin ?
                                null
                                :
                                <div className="ios-loader">
                                  <div className="bar bar1"></div><div className="bar bar2"></div>
                                  <div className="bar bar3"></div><div className="bar bar4"></div>
                                  <div className="bar bar5"></div><div className="bar bar6"></div>
                                  <div className="bar bar7"></div><div className="bar bar8"></div>
                                  <div className="bar bar9"></div><div className="bar bar10"></div>
                                  <div className="bar bar11"></div><div className="bar bar12"></div>
                                </div>
                            }

                            <div className="switch-edit">
                              <IconButton onClick={this.editSwitch.bind(this, obj)}>
                                <i className="material-icons white-fg font-1-2rem">mode_edit</i>
                              </IconButton>
                            </div>

                            <span>{obj.name}</span>

                            {hasFeature8 ? (
                              <div style={{ 
                                marginTop: '1rem', 
                                fontSize: '1.2rem', 
                                fontWeight: 'bold',
                                color: isChecked ? '#4caf50' : '#f44336'
                              }}>
                                {isChecked ? 'ON' : 'OFF'}
                              </div>
                            ) : (
                              <input className="toggle toggle__outline" type="checkbox"
                                disabled={obj.loaderFlag ? obj.loaderFlag : ''}
                                checked={isChecked}
                                onChange={(e) => {
                                  let x = this.state.device_statuses;
                                  if (this.state.device_avail && this.state.device_avail[obj.device_id]) {
                                    obj.loaderFlag = true;
                                    ds.postSwitchEvent({

                                      "device": obj.device_id,
                                      "userdevice": obj.UDid,
                                      "switch_no": obj.switch_no.toString(),
                                      "switch_state": e.target.checked ? 1 : 0,
                                      "act_type": "switch",
                                      "id": obj._id

                                    }, data => {
                                      x[obj._id] = e;
                                      this.setState({
                                        device_statuses: x
                                      });
                                      obj.loaderFlag = false;

                                    }, err => {
                                      obj.loaderFlag = false;
                                    });
                                  }
                                  else {
                                    if (this.state.isDemoLogin) {
                                      this.state.device_statuses[obj.device_id][obj.switch_no - 1] = e.target.checked;
                                      return;
                                    }
                                    alert("Device isn't responding :(")
                                  }
                                }}
                              />
                            )}
                          </section>
                        </div>
                      )})
                      : <h6>No switches found :( </h6>
                  }
                   {
                    this.state.current_devices && this.state.current_devices.length ?
                      this.state.current_devices.map((obj, ind) => {
                        if(obj.kiot_device_id && obj.kiot_device_id.dev_type && obj.kiot_device_id.dev_type == "SMART_LOCK_PRO"){
                          return (
                          <div className="col-md-2 col-6" style={{ marginBottom: "1rem", padding: "0 0.4rem" }}>
                          <section key={ind} className="dark-bg switch-box">
                          { obj.otp ? <div className="switch-edit">
                              <IconButton onClick={()=>{
                                 let current_devices = [];
                                 for(let i of this.state.current_devices){
                                   if(i._id == obj._id){
                                     i.otp = false;
                                   }
                                   current_devices.push(i);
                                 }
                                 this.setState({current_devices: current_devices});
                              }}>
                                <i className="material-icons white-fg font-1-2rem">refresh</i>
                              </IconButton>
                            </div> : null
                        }

                            <div style={{'fontSize':'2rem'}} onClick={(e)=>{
                              let startDate, endDate;
                              startDate = Date.now();
                              endDate = Date.now() + 1000 * 60 * 60 * 6;
                              ds.postLockOtp({
                                intent: 7,
                                hotel_id: ls.getUserDetails().hotel_id,
                                keyboardPwdName: "OTP" + Date.now(),
                                keyboardPwdType: 1,
                                UDid: obj._id,
                                startDate,
                                endDate,
                              }, ({ keyboardPwd }) => {
                                if (!keyboardPwd) {
                                 this.setState({
                                  dialog: {
                                    open: true,
                                    head: 'Error',
                                    body: 'OTP could not be generated. Try Again!',
                                    actions: [
                                      <FlatButton
                                        label="Okay"
                                        primary
                                        onClick={this.closeDialog.bind(this)}
                                      />
                                    ]
                                  },
                                 })
                                } else {
                                 let current_devices = [];
                                 for(let i of this.state.current_devices){
                                   if(i._id == obj._id){
                                     i.otp = true;
                                     i.passcode = keyboardPwd;
                                   }
                                   current_devices.push(i);
                                 }
                                 this.setState({current_devices: current_devices});
                                  // this.setState({
                                  //   dialog: {
                                  //     open: true,
                                  //     head: 'Success',
                                  //     body: 'Use this OTP to unlock the device - '+ keyboardPwd,
                                  //     actions: [
                                  //       <FlatButton
                                  //         label="Okay"
                                  //         primary
                                  //         onClick={this.closeDialog.bind(this)}
                                  //       />
                                  //     ]
                                  //   },
                                  //  })
                                }
                              },
                              (err) => {
                                 console.log(err);
                              })
                            }
                            }>
                              <IconButton>
                                {obj.otp ?
                                <i className="material-icons white-fg">lock_open</i> :
                                <i className="material-icons white-fg">lock</i>
                        }
                              </IconButton>
                            </div>

                            <span>{obj.device_name}</span>
                            { obj.otp ?
                            <span>OTP - {obj.passcode}</span> : null
                        }
                          </section>
                        </div>
                      )}
  })
                      : null
                  }
                </div>
              </section>


              {
                this.state.current_devices && this.state.current_devices.length ?
                  <section className="box box-default col-md-9 mt-4 customBox ml-1rem">
                    <div className="box-header">Devices</div>
                    <div className="box-body">

                      <Table
                        height={'35vh'}
                        fixedHeader={true}
                        fixedFooter={true}
                        selectable={false}
                        multiSelectable={false}
                        bodyStyle={{ overflow: 'visible', overflowY: 'auto' }}
                      >
                        <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
                          <TableRow>
                            <TableHeaderColumn tooltip="Device Name">Device Name</TableHeaderColumn>
                            <TableHeaderColumn tooltip="Device Type">Device Type</TableHeaderColumn>
                            <TableHeaderColumn tooltip="Device ID">Device ID</TableHeaderColumn>
                            <TableHeaderColumn tooltip='Options'>Options</TableHeaderColumn>
                          </TableRow>
                        </TableHeader>
                        <TableBody
                          displayRowCheckbox={false}
                          showRowHover={true}
                          stripedRows={false}
                        >
                          {this.state.current_devices.map((row, index) => (
                            <TableRow key={index}>
                              <TableRowColumn>{row.device_name}</TableRowColumn>
                              <TableRowColumn>{row.device_type_alias_name}</TableRowColumn>
                              <TableRowColumn>{row.kd_id}</TableRowColumn>
                              <TableHeaderColumn className="v-center">
                                {row.device_type_connectivity_type == 1 ? <a primary href={`#/app/rooms/configure/${this.state.byroom.room_id}_${row._id}_${row.kd_id}_${this.state.byroom.mqttPassword}`}>Configure</a> : null}
                                {row.device_type_identifier == "SMART_LOCK" || row.device_type_identifier == "KIOT_LOCK" ? <span><a primary href={`#/app/rooms/pair_lock/${row._id}_${this.state.byroom.room_id}`}>Pair</a>
                                  <a primary className="ml-2vw w-100" target={row._id + "___pACC"} href={`#/app/rooms/post_actions/${row._id}_${this.state.byroom.room_id}`}>Actions</a></span> : null}
                                {/* {row.kiot_device_id && row.kiot_device_id.dev_type && row.kiot_device_id.dev_type == "SMART_LOCK_PRO" ? 
                                <div style={{color:"#2196f3"}} className="cursor-pointer w-100" onClick={()=>{this.unlockdevice(row._id,row.kd_id)}}>Unlock Room</div>: null}   */}
                                {<div style={{color:"#2196f3"}} className="cursor-pointer w-100" onClick={()=>{this.checkForAdditionalSetting(row._id,row.kd_id)}}>Additional Settings</div>}
                                <div className="divider" />

                              </TableHeaderColumn>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>

                    </div>
                  </section>
                  : null
              }
            </div>
            : null
        }
      </div>
    )
  }
}

let SelectableList = makeSelectable(List);

function wrapState(ComposedComponent) {
  return class SelectableList extends React.Component {
    static propTypes = {
      children: PropTypes.node.isRequired,
    };

    componentWillMount() {
      this.setState({
        selectedIndex: this.props.defaultValue,
      });
    }

    handleRequestChange = (event, index) => {
      this.setState({
        selectedIndex: index,
      }, () => {
        this.props.currentIndexGetter(this.state.selectedIndex);
      });
    };

    render() {
      return (
        <ComposedComponent
          value={this.state.selectedIndex}
          onChange={this.handleRequestChange}
        >
          {this.props.children}
        </ComposedComponent>
      );
    }
  };
}

SelectableList = wrapState(SelectableList);


// WEBPACK FOOTER //
// ./components/rooms/RoomControlMain.js